const HighlightMixin = {
  methods: {
    _getHighlightedText(value, searchQueries) {
      if (value == null) {
        return '';
      }
      let drawIndexes = Array.from({length: value.length});

      if (!searchQueries) {
        return value;
      }

      const appNameLowered = value.toLowerCase();

      searchQueries
      .map(item => item.toLowerCase())
      .forEach((item) => {
        const isSearchMatch = appNameLowered.includes(item);

        if (!isSearchMatch) {
          return;
        }

        let searchIndex = 0;
        let appNameSearchIndex = appNameLowered.indexOf(item, searchIndex);
        const markHighlightIndexes = (index, i) => {
          if (i >= appNameSearchIndex && i < appNameSearchIndex + item.length) {
            return 1;
          }

          return index;
        };

        while (appNameSearchIndex !== -1) {
          const endIndex = appNameSearchIndex + item.length;

          drawIndexes = drawIndexes.map(markHighlightIndexes);
          searchIndex = endIndex;
          appNameSearchIndex = appNameLowered.indexOf(item, searchIndex);
        }
      });
      let startIndex = 0;
      let currentIndex = 0;
      const segmentIndexesCollection = [];

      while (currentIndex <= value.length) {
        if (drawIndexes[currentIndex] !== 1) {
          if (startIndex !== currentIndex) {
            segmentIndexesCollection.push([startIndex, currentIndex]);
          }

          startIndex = currentIndex + 1;
        }

        currentIndex += 1;
      }
      let result = '';
      let index = 0;

      segmentIndexesCollection.forEach((item) => {
        const [beginIndex, endIndex] = item;

        if (index < beginIndex) {
          result += value.substring(index, beginIndex);
          index = beginIndex;
        }

        result += `<span class="highlight">${value.substring(beginIndex,
            endIndex)}</span>`;
        index = endIndex;
      }, '');

      if (index < value.length) {
        result += value.substring(index, value.length);
      }

      return result;
    },
  },
};

export default HighlightMixin;
